import { render, staticRenderFns } from "./roomChoose.vue?vue&type=template&id=33844779&scoped=true&"
import script from "./roomChoose.vue?vue&type=script&lang=js&"
export * from "./roomChoose.vue?vue&type=script&lang=js&"
import style0 from "./roomChoose.vue?vue&type=style&index=0&id=33844779&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33844779",
  null
  
)

export default component.exports